import React from 'react';
import { connect } from 'react-redux';
import { Modal, Text } from '@simplybenefits/sb-ui-library';
import { useLottie } from "lottie-react";
import failedAnimation from "../../../../assets/failed-animation.json";

/**
 * This is the failed animation component which uses the lottie-react library
 */
const FailedAnimation = () => {
    const options = {
        animationData: failedAnimation,
        loop: false
    };

    const { View } = useLottie(options);

    return (
        <div 
            style={{
                marginTop: -40,
                marginBottom: -40
            }}
        >
            { View }
        </div>
    );
};

/**
 *
 * @param {*} param0
 */
const ClaimErrorModal = ({ type, onClose, errors, loader }) => (
    <Modal
        open={true}
        loader={ loader }
        onClose={ onClose }
        primaryButton={{
            label: "Done",
            color: "error",
            onClick: onClose
        }}
    >
        <FailedAnimation/>

        <Text
            align="center"
            color="#D93025"
            display="block"
            extraLarge
            bold
        >
            { `Dental ${ type } Failed!` }
        </Text>

        <Text
            align="center"
            color="#D93025"
            display="block"
            margin="20px 0 0 0"
            medium
        >
            { `Transaction failed due to the following error(s)` }
        </Text>

        <div style={{ whiteSpace: 'pre-line' }}>
            <Text
                align="center"
                color="#D93025"
                display="block"
                margin="10px 0 0 0"
                small
                bold
            >
                { errors }
            </Text>
        </div>
    </Modal>
);

export default connect()(ClaimErrorModal);